<template>
  <div v-if="cerfa">
    <div>
      <div class="header">
        <h3>Nature des travaux</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label"><b>Type(s) de travaux :</b></label>
            </b-col>
            <b-col
              xl="10"
              lg="9"
              md="9"
              sm="12"
              cols="12"
              class="form-with-label"
            >
              <b-form-checkbox-group
                v-model="themes"
                :options="natures"
              ></b-form-checkbox-group>
            </b-col>
            <!-- <table class="table-front">
                                <tr>
                                    <th class="no-border"></th>
                                    <th>Pose de clôtures</th>
                                    <th>Pose de portail (portillon)</th>
                                    <th>Plantations</th>
                                </tr>
                                <tr>
                                    <td><label class="control-label no-padding">A l'alignement</label></td>
                                    <td>
                                        <b-form-radio-group class="marginLeft-15" v-model="cerfa.installationFencesAlignment" :options="options"></b-form-radio-group>
                                    </td>
                                    <td>
                                        <b-form-radio-group class="marginLeft-15" v-model="cerfa.installationGateAlignment" :options="options"></b-form-radio-group>
                                    </td>
                                    <td>
                                        <b-form-radio-group class="marginLeft-15" v-model="cerfa.installationPlantationAlignment" :options="options"></b-form-radio-group>
                                    </td>
                                </tr>
                                <tr>
                                    <td><label class="control-label no-padding">En retrait de l'alignement</label></td>
                                    <td>
                                        <b-row class="no-margin">
                                            <b-col lg="9" md="8" sm="12" cols="12">
                                                <b-form-input  :number="true" v-model="cerfa.installationFencesBackAlignment" class="form-control send-api" placeholder="Clôture"/>
                                            </b-col>
                                            <b-col lg="3" md="4" sm="12" cols="12" class="text-center">
                                                <div class="control-label font-normal">
                                                    mètres
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </td>
                                    <td>
                                        <b-row class="no-margin">
                                            <b-col lg="9" md="8" sm="12" cols="12">
                                                <b-form-input v-model="cerfa.installationGateBackAlignment" class="form-control send-api" placeholder="Portail"/>
                                            </b-col>
                                            <b-col lg="3" md="4" sm="12" cols="12" class="text-center">
                                                <div class="control-label font-normal">
                                                    mètres
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </td>
                                    <td>
                                        <b-row class="no-margin">
                                            <b-col lg="9" md="8" sm="12" cols="12">
                                                <b-form-input v-model="cerfa.installationPlantationBackAlignment" class="form-control send-api" placeholder="Plantations"/>
                                            </b-col>
                                            <b-col lg="3" md="4" sm="12" cols="12" class="text-center">
                                                <div class="control-label font-normal">
                                                    mètres
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4" class="text-center"> -->
            <!-- </td>
                                </tr>
                            </table> -->
          </b-row>
        </div>
      </div>
    </div>
    <!-- DEPOT OU STATIONNEMENT -->
    <div
      v-if="
        cerfa.themes && cerfa.themes.split(',').includes('depot_stationnement')
      "
    >
      <div class="header">
        <h3>Dépôt ou stationnement</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Type de demande :</label>
            </b-col>
            <b-col
              xl="10"
              lg="9"
              md="9"
              sm="12"
              cols="12"
              class="form-with-label"
            >
              <b-form-radio-group
                v-model="cerfa.parkingExtension"
                :options="parking_extension"
              ></b-form-radio-group>
            </b-col>
            <b-col
              v-if="cerfa.parkingExtension === true"
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="no-padding"
            >
              <b-row class="no-margin">
                <b-col
                  xl="4"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Référence du permis de stationnement</label
                  >
                </b-col>
                <b-col xl="8" lg="9" md="9" sm="12" cols="12">
                  <b-form-input
                    v-model="cerfa.parkingPermit"
                    class="form-control send-api"
                    placeholder="Référence du permis de stationnement"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <label class="control-label nopadding" style="text-align:left;"
                >Nature du dépôt ou stationnement</label
              >
            </b-col>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <!-- TODO CONCATENER LES VALEURS DANS UNE SEULE CLE : parking_nature -->
              <b-form-checkbox-group v-model="parkingNature">
                <b-form-checkbox value="materiaux" class="icheck send-api">
                  Matériaux</b-form-checkbox
                >
                <b-form-checkbox value="benne" class="icheck send-api">
                  Benne</b-form-checkbox
                >
                <b-form-checkbox value="grue" class="icheck send-api">
                  Grue</b-form-checkbox
                >
                <b-form-checkbox value="etalage" class="icheck send-api">
                  Etalage</b-form-checkbox
                >
                <b-form-checkbox value="echafaudage" class="icheck send-api">
                  Echafaudage</b-form-checkbox
                >
                <b-form-checkbox
                  value="mobilier_urbain"
                  class="icheck send-api"
                >
                  Mobilier Urbain</b-form-checkbox
                >
                <b-form-checkbox value="terrasse_cafe" class="icheck send-api">
                  Terasses de café</b-form-checkbox
                >
                <b-form-checkbox value="vente_sur_voie" class="icheck send-api">
                  Vente le long de la voie ou sur aire de
                  service</b-form-checkbox
                >
                <b-form-checkbox value="autre_nature" class="icheck send-api">
                  Autres</b-form-checkbox
                >
              </b-form-checkbox-group>
            </b-col>
            <b-col
              v-if="
                cerfa.parkingNature !== null &&
                  cerfa.parkingNature.includes('autre_nature')
              "
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="no-padding marginTopSmall"
              id="section-nature"
            >
              <b-row class="no-margin">
                <b-col
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Préciser</label>
                </b-col>
                <b-col xl="10" lg="9" md="9" sm="12" cols="12">
                  <b-form-input
                    v-model="cerfa.parkingNatureOther"
                    class="form-control send-api"
                    placeholder="Préciser nature du dépôt ou stationnement"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- SAILLIE OU SURPLOMB -->
    <div
      v-if="
        cerfa.themes && cerfa.themes.split(',').includes('saillie_surplomb')
      "
    >
      <div class="header">
        <h3>Saillie ou surplomb</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row class="no-margin">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="5"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Largeur de la voie :</label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    :number="true"
                    v-model="cerfa.trackWidth"
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="3"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">mètres</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="5"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Largeur de la saillie :</label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    :number="true"
                    v-model="cerfa.protrusionWidth"
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="3"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">mètres</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="5"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Largeur des trottoirs :</label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    :number="true"
                    v-model="cerfa.sidewalkWidth"
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="3"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">mètres</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="5"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Hauteur sous saillie :</label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    :number="true"
                    v-model="cerfa.heightUnderProtrusion"
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="3"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">mètres</div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- AMENAGEMENT D'ACCES -->
    <div
      v-if="
        cerfa.themes && cerfa.themes.split(',').includes('amenagement_acces')
      "
    >
      <div class="header">
        <h3>Aménagement d'accès</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12" class="no-padding">
              <label class="control-label">Franchissement de fossé :</label>
            </b-col>
            <b-col
              xl="9"
              lg="9"
              md="8"
              sm="12"
              cols="12"
              class="form-with-label"
            >
              <b-form-radio-group
                v-model="cerfa.ditchCrossing"
                :options="fosse"
              ></b-form-radio-group>
              <!--<b-form-checkbox v-model="cerfa.ditchCrossing" value="true" class="icheck send-api"> Avec franchissement de fossé</b-form-checkbox>
                            <b-form-checkbox v-model="cerfa.ditchCrossing" value="false" class="icheck send-api"> Sans franchissement de fossé</b-form-checkbox>-->
            </b-col>
          </b-row>

          <b-row v-if="cerfa.ditchCrossing === true">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="5"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Diamètre du tuyau :</label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    :number="true"
                    v-model="cerfa.pipeDiameter"
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="3"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">mètres</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="5"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Longueur :</label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    :number="true"
                    v-model="cerfa.pipeLength"
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="3"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">mètres</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="6"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Distance par rapport à l'axe de la chaussée :</label
                  >
                </b-col>
                <b-col xl="3" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    :number="true"
                    v-model="cerfa.distanceFromRoad"
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="3"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">mètres</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="4" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="6"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Nature du tuyau :</label>
                </b-col>
                <b-col xl="6" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    v-model="cerfa.typePipe"
                    class="form-control send-api"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-else-if="cerfa.ditchCrossing === false">
            <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
              <label class="control-label">Largueur de l'aménagement :</label>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" cols="12">
              <b-form-input
                :number="true"
                v-model="cerfa.layoutWidth"
                class="form-control send-api"
              />
            </b-col>
            <b-col xl="5" lg="4" md="4" sm="12" cols="12" class="no-padding">
              <div class="control-label font-normal text-left">mètres</div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- OUVRAGES DIVERS -->
    <div
      v-if="cerfa.themes && cerfa.themes.split(',').includes('ouvrage_divers')"
    >
      <div class="header">
        <h3>Ouvrages divers</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Type d'ouvrage :</label>
            </b-col>
            <b-col
              xl="10"
              lg="9"
              md="9"
              sm="12"
              cols="12"
              class="form-with-label"
            >
              <b-form-radio-group
                v-model="cerfa.newInstallation"
                :options="installations"
              ></b-form-radio-group>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <label class="control-label" style="text-align:left;"
                >Réseaux aériens ou souterrains ou branchement :</label
              >
            </b-col>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <!-- TODO CONCATENER LES VALEURS DANS UNE SEULE CLE : network_connection -->
              <b-form-checkbox-group v-model="networkConnection">
                <b-form-checkbox value="eau_potable" class="icheck send-api">
                  Eau potable</b-form-checkbox
                >
                <b-form-checkbox value="eaux_pluviales" class="icheck send-api">
                  Eaux pluviales</b-form-checkbox
                >
                <b-form-checkbox value="gdf" class="icheck send-api">
                  GDF</b-form-checkbox
                >
                <b-form-checkbox
                  value="operateurs_reseaux"
                  class="icheck send-api"
                >
                  Opérateurs réseaux</b-form-checkbox
                >
                <b-form-checkbox value="eaux_usees" class="icheck send-api">
                  Eaux usées</b-form-checkbox
                >
                <b-form-checkbox value="edf" class="icheck send-api">
                  EDF</b-form-checkbox
                >
                <b-form-checkbox
                  value="autre"
                  class="icheck send-api toggle"
                  data-toggle="section_branchement"
                >
                  Autres</b-form-checkbox
                >
              </b-form-checkbox-group>
            </b-col>
            <b-col
              v-if="
                cerfa.networkConnection !== null &&
                  cerfa.networkConnection.includes('autre')
              "
              xl="12"
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="no-padding marginTopSmall"
              id="section_branchement"
            >
              <b-form-input
                v-model="cerfa.networkConnectionOther"
                class="form-control send-api"
                placeholder="Préciser"
              />
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
              <table class="table-front">
                <tr>
                  <th class="no-border"></th>
                  <th>Sous voirie</th>
                  <th>Sous accotement ou trottoirs</th>
                </tr>
                <tr>
                  <td>
                    <label class="control-label no-padding lh-44"
                      >Tranchée longitudinale</label
                    >
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input
                          :number="true"
                          v-model="cerfa.longitudinalTrenchUnderRoad"
                          class="form-control send-api"
                        />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div
                          class="text-center control-label font-normal no-padding lh-44"
                        >
                          mètres
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input
                          :number="true"
                          v-model="cerfa.longitudinalTrenchUnderSidewalks"
                          class="form-control send-api"
                        />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div
                          class="text-center control-label font-normal no-padding lh-44"
                        >
                          mètres
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="control-label no-padding lh-44"
                      >Tranchée transversale</label
                    >
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input
                          :number="true"
                          v-model="cerfa.transverseTrenchUnderRoad"
                          class="form-control send-api"
                        />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div
                          class="text-center control-label font-normal no-padding lh-44"
                        >
                          mètres
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input
                          :number="true"
                          v-model="cerfa.transverseTrenchUnderSidewalks"
                          class="form-control send-api"
                        />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div
                          class="text-center control-label font-normal no-padding lh-44"
                        >
                          mètres
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="control-label no-padding lh-44"
                      >Fonçage</label
                    >
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input
                          :number="true"
                          v-model="cerfa.drivingUnderRoad"
                          class="form-control send-api"
                        />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div
                          class="text-center control-label font-normal no-padding lh-44"
                        >
                          mètres
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input
                          :number="true"
                          v-model="cerfa.drivingUnderSidewalks"
                          class="form-control send-api"
                        />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div
                          class="text-center control-label font-normal no-padding lh-44"
                        >
                          mètres
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
              </table>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <label class="control-label" style="text-align:left;"
                >Aménagement de surface ou équipements</label
              >
            </b-col>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <!-- TODO CONCATENER LES VALEURS DANS UNE SEULE CLE : surface_planning_equipment -->
              <b-form-checkbox-group v-model="surfacePlanningEquipment">
                <b-form-checkbox value="stationnement" class="icheck send-api">
                  Stationnement</b-form-checkbox
                >
                <b-form-checkbox value="arret_bus" class="icheck send-api">
                  Arrêt bus</b-form-checkbox
                >
                <b-form-checkbox
                  value="passage_sup_inf"
                  class="icheck send-api"
                >
                  Passage supérieur ou inférieur</b-form-checkbox
                >
                <b-form-checkbox
                  value="equipement_route"
                  class="icheck send-api"
                >
                  Equipements de la route</b-form-checkbox
                >
                <b-form-checkbox
                  value="autre_amenagement"
                  class="icheck send-api"
                >
                  Autres</b-form-checkbox
                >
              </b-form-checkbox-group>
            </b-col>
            <b-col
              v-if="
                cerfa.surfacePlanningEquipment !== null &&
                  cerfa.surfacePlanningEquipment.includes('autre_amenagement')
              "
              xl="12"
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="no-padding marginTopSmall"
              id="section_amenagement"
            >
              <b-form-input
                v-model="cerfa.surfacePlanningEquipmentOther"
                class="form-control send-api"
                placeholder="Préciser"
              />
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
export default {
  name: "NatureTravauxD14023",
  props: ["value"],
  methods: {
    ...Vuex.mapActions("Cerfa", ["setCerfa14023"]),
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14023"]),
    cerfa: {
      get: function() {
        return this.cerfa14023;
      },
      set: function(newValue) {
        this.setCerfa14023(newValue);
      },
    },
    parkingNature: {
      get() {
        if (this.cerfa.parkingNature == null) return [];
        else return this.cerfa.parkingNature.split(",");
      },
      set(value) {
        this.cerfa.parkingNature = value.join(",");
      },
    },
    themes: {
      get() {
        if (this.cerfa.themes == null) return [];
        else return this.cerfa.themes.split(",");
      },
      set(value) {
        this.cerfa.themes = value.join(",");
      },
    },
    surfacePlanningEquipment: {
      get() {
        if (this.cerfa.surfacePlanningEquipment == null) return [];
        else return this.cerfa.surfacePlanningEquipment.split(",");
      },
      set(value) {
        this.cerfa.surfacePlanningEquipment = value.join(",");
      },
    },
    networkConnection: {
      get() {
        if (this.cerfa.networkConnection == null) return [];
        else return this.cerfa.networkConnection.split(",");
      },
      set(value) {
        this.cerfa.networkConnection = value.join(",");
      },
    },
  },
  data() {
    return {
      options: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],

      // naturesTvx: [
      //   {
      //     text: "Création/Suppression d’infrastructures souterraines",
      //     value: "Création/Suppression d’infrastructures souterraines",
      //   },
      //   {
      //     text: "Création/Suppression d’infrastructures aériennes ",
      //     value: "Création/Suppression d’infrastructures aériennes ",
      //   },
      //   {
      //     text: "Pose/Dépose d’armoire ou Shelter",
      //     value: "Pose/Dépose d’armoire ou Shelter",
      //   },
      //   {
      //     text: "Réparation d’infrastructures existantes",
      //     value: "Réparation d’infrastructures existantes",
      //   },
      //   { text: "Travaux de câblage", value: "Travaux de câblage" },
      // ],

      natures: [
        // {text: 'Dépôt ou stationnement', value: 'depot_stationnement'},
        // {text: 'Saillie ou Surplomb', value: 'saillie_surplomb'},
        // {text: 'Aménagement d\'accès', value: 'amenagement_acces'},
        // {text: 'Pose de compteur / branchement aux réseaux', value: 'pose_compteur'},
        { text: "Ouvrages divers", value: "ouvrage_divers", checked: true },
      ],
      works: [
        { text: "Station service", value: "station_service" },
        { text: "Renouvellement", value: "renouvellement" },
        { text: "Création", value: "creation" },
        { text: "Autres", value: "autres" },
      ],
      parking_extension: [
        { text: "Demande initiale", value: false },
        { text: "Prolongation", value: true },
      ],
      installations: [
        { text: "Travaux sur ouvrages existants", value: false },
        { text: "Installation nouvelle", value: true },
      ],
      fosse: [
        { text: "Avec franchissement de fossé", value: true },
        { text: "Sans franchissement de fossé", value: false },
      ],
    };
  },
};
</script>

<style scoped></style>
